import './authModal.scss';
import React, {FormEvent, useContext, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {AxiosResponse} from 'axios';
import {Button, InputAdornment, TextField, IconButton} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import google from '../images/google.svg';
import facebook from '../images/facebook.svg';
import apple from '../images/apple.svg';
import closeIcon from '../images/close.svg';
import {authService} from '../../services/auth.service';
import useSnackBar from '../../hooks/useSnackBar';
import {AuthContext} from "../../context/AuthProvider";

function AuthModal({close, openRegister, openPassReset}: any) {
    const {setAuthenticated} = useContext(AuthContext);
    const {setSnackBar} = useSnackBar();
    const [passwordErrorText, setPasswordErrorText] = useState('');
    const [emailErrorText, setEmailErrorText] = useState('');

    const [fields, setFields] = useState({
        email: '',
        password: '',
    });

    const navigate = useNavigate();

    const loginHandler = (e: FormEvent) => {
        e.preventDefault();
        let changedEmail = fields.email.toLocaleLowerCase().replace(/\s/g, "")
        if (!changedEmail) setEmailErrorText('Введите email');
        else if (!changedEmail.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )?.length) setEmailErrorText('Введите верный email');
        else {
            setEmailErrorText('');

            if (!fields.password) {
                setPasswordErrorText('Введите пароль');
            } else {
                setEmailErrorText('');
                setPasswordErrorText('');

                authService.login(changedEmail, fields.password).then((response: AxiosResponse) => {
                    localStorage.setItem('token', response.data.access_token);
                    localStorage.setItem('refreshToken', response.data.refresh_token);
                    setAuthenticated(true);
                    navigate('/');
                    close();
                }).catch(function (e) {
                    setSnackBar({title: e.response.data.detail, isActive: true, status: 'error'});
                    if (e.response.data.detail === 'EMAIL_OR_PASSWORD_INVALID') {
                        setEmailErrorText('Нет такой учетной записи')
                    }
                });
            }
        }
    }

    const handleEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFields({...fields, email: e.target.value});
        if (fields.email) setEmailErrorText('');
    }
    const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFields({...fields, password: e.target.value});
        if (fields.password) setPasswordErrorText('');
    }

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const googleLogin = () => {
        authService.getGoogleUrl().then((response) => {
            window.location.href = response.data?.url;
        });
    };
    const facebookLogin = () => {
        authService.getFacebookUrl().then((response) => {
            window.location.href = response.data?.url;
        });
    };

    const iOS = () => {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    }

    return (
        <div className="modal-content">
            <button onClick={() => close()} className="close-btn">
                <img src={closeIcon} alt="close-modal"/>
            </button>
            <form className="auth-modal-content" onSubmit={loginHandler}>
                <h3>Вход в учетную запись</h3>
                <div className="to-register-text">
                    У вас еще нет учетной записи?
                    <span className="to-register-link" onClick={openRegister}>Зарегистрироваться</span>
                </div>

                <TextField
                    variant="outlined"
                    sx={{marginTop: '32px'}}
                    error={emailErrorText?.length > 0}
                    helperText={emailErrorText}
                    onChange={handleEmail}
                    label="Электронная почта"
                />

                <TextField
                    variant="outlined"
                    sx={{marginTop: '24px'}}
                    type={showPassword ? 'text' : 'password'}
                    error={passwordErrorText?.length > 0}
                    helperText={passwordErrorText}
                    onChange={handlePassword}
                    label="Пароль"
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                        </InputAdornment>
                    }}
                />
                <Button sx={{marginTop: '40px'}} variant="contained" className="blue-btn" type="submit">Войти</Button>
                <span className="forgot-link" onClick={openPassReset}>Забыли пароль?</span>
                <div className="divider"><span>Или</span></div>
                <div className="alternatives">
                    <div className="alternative" onClick={() => googleLogin()}><img src={google} alt="google-login"/>Войти
                        через Google
                    </div>
                    <div className="alternative" onClick={() => facebookLogin()}><img src={facebook}
                                                                                      alt="facebook-login"/>Войти через
                        Facebook
                    </div>
                    {iOS() && <div className="alternative"><img src={apple} alt="apple-login"/>Войти через Apple</div>}
                </div>
            </form>
        </div>
    );
}

export default AuthModal;
